<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Transactions from 'src/components/#common/Transactions.svelte';
</script>

<svelte:head>
    <title>Transactions</title>
</svelte:head>

<MainLayout title="Transactions">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Transactions/>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>